/*
 * Basisschool pagina
 */

// Settings to the carousel init
function getSliderSettings() {
  return {
    dots:           true,
    infinite:       false,
    speed:          300,
    slidesToShow:   4,
    slidesToScroll: 4,
    responsive:     [
      {
        breakpoint: 1310,
        settings:   {
          slidesToShow:   3,
          slidesToScroll: 3,
          infinite:       false,
          dots:           true
        }
      },
      {
        breakpoint: 768,
        settings:   {
          slidesToShow:   2,
          slidesToScroll: 2,
          infinite:       false
        }
      },
      {
        breakpoint: 480,
        settings:   {
          slidesToShow:   1,
          slidesToScroll: 1,
          infinite:       false
        }
      }
    ]
  }
}

// Check if the number of slides is enough to init the carousel
function carouselInit(elementSelector) {
  let carouselLength = $(elementSelector).find('.product-card-wrapper').length;
  let bodyWidth = $('body').width();
  if (bodyWidth > 900) {
    bodyWidth = 900;
  }
  return bodyWidth / carouselLength < 220;
}
jQuery( function( $ ) {
  // Form modal
  $('.OpenFormModal')
    .each(function(index){
      $(document.body)
        .on('click', '#OpenFormModal'+(index+1), function (e) {
          e.preventDefault();
          $('#FormModal'+(index+1))
            .modal('show');
        });
    });

  // Declare variables with initial values of the selector
  let current_vak = 'null';
  let current_groep = 0;
  // On select vak or groep
  $('.subcategories_filters')
    .on('change', '#kies_vak, #kies_groep', function () {

      // Update variables with current selected value
      current_vak = $('#kies_vak').val();
      current_groep = $('#kies_groep').val();

      // Show/hide results based on the selected values
      if (( current_vak == 'null' ) && ( current_groep == 0 )) {
        $('.blog-page__card,.blok_inhoud').show();
      } else if ( current_groep == 0 ) {
        $('.blog-page__card,.blok_inhoud').hide();
        $('[data-vak="'+current_vak+'"],[data-vak="null"]').show();
      } else if ( current_vak == 'null' ) {
        $('.blog-page__card,.blok_inhoud').hide();
        $('[data-groep="'+current_groep+'"],[data-groep="0"]').show();
      } else {
        $('.blog-page__card,.blok_inhoud').hide();
        $('[data-groep="'+current_groep+'"][data-vak="'+current_vak+'"],' +
          '[data-vak="null"][data-groep="'+current_groep+'"],' +
          '[data-vak="'+current_vak+'"][data-groep="0"]').show();
      }

      // Check if there are results
      if($('.blog-page').children(':visible').length == 0) {
        $('.melding_geen_resultaten').show();
      } else {
        $('.melding_geen_resultaten').hide();
      }
    });

  // Change position of the text for the books in the list
  $( '.lijst_item' ).each(function() {
    $(this).find('.product-card')
      .append($(this).find('.boek_tekst'));
  });

  // Check and init carousel
  if(carouselInit('.boekenlijst')) {
    $('.boekenlijst')
      .css('display', 'block')
      .slick(getSliderSettings());
  }
});
